import styled from "styled-components";


export const DropZoneWrapper = styled.div`
	position: relative;
`;